import { initReactI18next } from 'react-i18next';
import i18next from 'i18next';

import translationEN from 'src/translations/en/translation.json';
import translationIT from 'src/translations/it/translation.json';
import translationFR from 'src/translations/fr/translation.json';
import translationDE from 'src/translations/de/translation.json';
import { getInitialLanguage } from 'src/utils/language';

const resources = {
  en: {
    translation: translationEN
  },
  it: {
    translation: translationIT
  },
  fr: {
    translation: translationFR
  },
  de: {
    translation: translationDE
  }
};

i18next
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: getInitialLanguage(),
    fallbackLng: 'en',
    supportedLngs: ['en', 'it', 'fr', 'de'],
    // Bundled resources must be ready before module-level labels are evaluated.
    initImmediate: false,
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });
export default i18next;
